/**
 * @generated SignedSource<<439caa7e663cf3d64aa3a1963daaf1ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type AHTeamIcon$data = {
  readonly icon: TeamIcon | null;
  readonly " $fragmentType": "AHTeamIcon";
};
export type AHTeamIcon$key = {
  readonly " $data"?: AHTeamIcon$data;
  readonly " $fragmentSpreads": FragmentRefs<"AHTeamIcon">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AHTeamIcon",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "77b5189b13b599bd9e7108a6942cf674";

export default node;
